import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import WaitPayOrder from '@/views/ViewsComponents/badDebt/WaitPayOrder.vue'
import ConfirmedOrder from '@/views/ViewsComponents/badDebt/ConfirmedOrder.vue'
import BadOrderList from '@/views/ViewsComponents/badDebt/BadOrderList.vue'
import RecollectionOrder from '@/views/ViewsComponents/badDebt/RecollectionOrder.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "待收款订单" }, {
          default: _withCtx(() => [
            _createVNode(WaitPayOrder)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { label: "确认坏账" }, {
          default: _withCtx(() => [
            _createVNode(ConfirmedOrder)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "申报坏账",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(BadOrderList)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "重新收款记录",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(RecollectionOrder)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})